import { Box, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { ReactPlayerProps } from 'react-player';
import DialogMediaPlayer from '../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { AudioContentPanelStyle } from './AudioContentPanelStyle';
import { PLayerTriggeredBy } from '../../../../../../commands/practitioner/enums/PLayerTriggeredBy';

interface AudioContentPanelProps {
  className?: string;
  index: number;
  value: number;
}

const AudioContentPanel = (props: AudioContentPanelProps) => {
  const { index, value } = props;

  const { practitionerMediaURI } = usePractitionerControlsContext();

  const { audioTabContainer } = AudioContentPanelStyle;

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
  };

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={audioTabContainer}
    >
      {value === index && (
        <>
          <Box className={'audio-container'}>
            <DialogMediaPlayer
              key={practitionerMediaURI}
              ReactPlayerProps={reactPlayerPreview}
              ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default AudioContentPanel;
